import { Location } from '@angular/common';
import { ParamMap, Router } from '@angular/router';
import { RequiredPermission } from '../models/settlement-permissions.model';
import { AuthService } from '../services/auth.service';
import { AppContextService } from '../services/app-context.service';

export function computeDefaultRoute(auth: AuthService, appCtx: AppContextService): string {
  const allowed = (permission: RequiredPermission | RequiredPermission[]) =>
    (Array.isArray(permission) ? permission : [permission]).some((req) => auth.hasPermission(req.resource, req.scope));

  const first = appCtx
    .getNavSections()
    .flatMap((section) => section.items)
    .find((item) => allowed(item.permission));

  return first?.route ?? '/login';
}

export function stripQueryParam(params: ParamMap, key: string, router: Router, location: Location): void {
  const remaining = new URLSearchParams();

  params.keys.filter((k) => k !== key).forEach((k) => params.getAll(k).forEach((entry) => remaining.append(k, entry)));

  location.replaceState(router.url.split('?')[0], remaining.toString());
}
